import t from "vue";
var e = function e(t, _e, r) {
    return Array.isArray(_e) ? 1 === _e.length && _e[0].tag ? _e[0] : t(r, {}, _e) : _e;
  },
  r = t.extend({
    name: "MediaQueryProvider",
    props: {
      queries: {
        type: Object,
        required: !0
      },
      fallback: [String, Array],
      wrapperTag: {
        type: String,
        default: "span"
      },
      ssr: {
        type: Boolean
      }
    },
    provide: function provide() {
      return {
        mediaQueries: this.mediaQueries
      };
    },
    data: function data() {
      var t = {},
        e = this.fallback,
        r = this.queries;
      return Object.keys(r).forEach(function (e) {
        t[e] = !1;
      }), e && (Array.isArray(e) ? e.forEach(function (e) {
        t[e] = !0;
      }) : t[e] = !0), {
        mediaQueries: t,
        matchers: []
      };
    },
    beforeMount: function beforeMount() {
      this.ssr || this.$nuxt || this.bootstrap();
    },
    mounted: function mounted() {
      (this.ssr || this.$nuxt) && this.bootstrap();
    },
    beforeDestroy: function beforeDestroy() {
      this.matchers.forEach(function (t) {
        var e = t[0],
          r = t[1];
        e.removeListener(r);
      });
    },
    methods: {
      bootstrap: function bootstrap() {
        var e = this,
          r = this.queries,
          i = this.mediaQueries,
          s = function s(_s) {
            var n = r[_s],
              o = window.matchMedia(n),
              h = function h(r) {
                e.$emit("change:" + _s, r), t.set(i, _s, r.matches);
              };
            o.addListener(h), t.set(i, _s, o.matches), a.matchers.push([o, h]);
          },
          a = this;
        for (var n in r) s(n);
      }
    },
    render: function render(t) {
      return e(t, this.$slots.default, this.wrapperTag);
    }
  }),
  i = t.extend({
    name: "MatchMedia",
    inject: {
      mediaQueries: {
        default: null
      }
    },
    props: {
      query: {
        type: String
      },
      fallback: {
        type: Boolean
      },
      wrapperTag: {
        type: String,
        default: "span"
      },
      ssr: {
        type: Boolean
      }
    },
    data: function data() {
      return {
        matcher: null,
        matches: this.fallback
      };
    },
    beforeMount: function beforeMount() {
      this.ssr || this.$nuxt || this.bootstrap();
    },
    mounted: function mounted() {
      (this.ssr || this.$nuxt) && this.bootstrap();
    },
    beforeDestroy: function beforeDestroy() {
      this.matcher && (this.matcher.removeListener(this.onMedia), this.matcher = null);
    },
    methods: {
      bootstrap: function bootstrap() {
        if (this.query) {
          var t = this.matcher = window.matchMedia(this.query);
          t.addListener(this.onMedia), this.matches = t.matches;
        }
      },
      onMedia: function onMedia(t) {
        this.$emit("change", t), this.matches = t.matches;
      }
    },
    computed: {
      slotProps: function slotProps() {
        return this.query ? {
          matches: this.matches
        } : (this.mediaQueries || console.error("\n            [vue-component-media-queries]:\n            <MatchMedia /> should be a descendant of a <MediaQueryProvider /> component tree or have a 'query' prop.\n          "), this.mediaQueries);
      }
    },
    render: function render(t) {
      return e(t, this.$scopedSlots.default(this.slotProps), this.wrapperTag);
    }
  });
export { i as MatchMedia, r as MediaQueryProvider };